import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { CookieManagerService } from './cookie-manager.service';
import { RegistrationFeeTokenService } from './registration-fee-token.service';
import { CookieNames, HeaderTypes, defaultLanguage } from '../../core-modules/constant';

@Injectable()
export class HttpClientService {

  /**
   * assign default header details
   */
  private contentType: string = HeaderTypes.contentType;
  private language: string = HeaderTypes.language;
  private defaultHeaderValue: string = HeaderTypes.defaultHeaderValue;
  private fileUploadHeaderValue: string = HeaderTypes.fileUploadHeaderValue;
  private authKey: string = HeaderTypes.authKey;
  private userId: string = HeaderTypes.userId;
  private setId: string = HeaderTypes.setid;
  private catagoryId: string = HeaderTypes.catagoryId;
  private headerVariable: Array<any>;

  /**
   * assign cookie names
   */
  private loginKey: string = CookieNames.loginKey;
  private loginUser: string = CookieNames.userobj;
  /**
   * depenedecy Injectable
   * @param {Http} http
   * @param {CookieManagerService} cookieManagerService
   * @param {RegistrationFeeTokenService} registrationFeeTokenService
   */
  constructor(
    private http: Http,
    private cookieManagerService: CookieManagerService,
    private registrationFeeTokenService : RegistrationFeeTokenService
    ) {
    this.http = http;
    this.cookieManagerService = cookieManagerService;
   this.registrationFeeTokenService = registrationFeeTokenService;
  }

  /**
   * create header for call non authorize api
   * @param {Headers} headers
   */
  createHeader(headers: Headers) {
    headers.append(this.contentType, this.defaultHeaderValue);
    var language = this.cookieManagerService.getCookie("Lang", false);
    headers.append(this.language, language ? language : defaultLanguage);
  }

  /**
   * create header for call authorize api with token
   * @param {Headers} headers
   */
  createAuthorizationHeader(headers: Headers) {
    try {
      let token = this.cookieManagerService.getCookie(this.loginKey, false).toString();

      if(!token.toLowerCase().startsWith('bearer')){
        token = "Bearer " + token;
      }

      headers.append(this.contentType, this.defaultHeaderValue);
      headers.append(this.authKey, token);

      var language = this.cookieManagerService.getCookie("Lang", false);
      headers.append(this.language, language ? language : defaultLanguage);

      let userObj = this.cookieManagerService.getCookie(this.loginUser, false);

      let user = userObj ? JSON.parse(userObj.toString()) : null;
      let id;
      if (user) {
        id = user._id;
      }
      headers.append(this.userId, id);
      return headers;
    } catch (exception) {
      return Observable.throw(exception);
    }
  }

  /**
   * call nonauthorize http get
   * @param {string} url
   */
  get(url: string) {
    let headers = new Headers();
    this.createHeader(headers);
    return this.http.get(url, { headers: headers }).map(this.extractData).catch(this.handleError);
  }

  /**
   * call nonauthorize http get external
   * @param {string} url
   */
  getYoutube(url: string) {
    return this.http.get(url).map(this.extractData).catch(this.handleError);
  }


  /**
   * call authorize http get
   * @param {string} url
   */
  authGet(url: string, setid: any) {
    if (setid && typeof setid === 'object')
      var d = Object.keys(setid).length;

    let headers = new Headers();
    if (d > 1) {
      headers.append(this.setId, String(setid.setid));
      headers.append(this.catagoryId, String(setid.catagoryid));
    } else {
      headers.append(this.setId, String(setid));
    }
    let header = new Headers(this.createAuthorizationHeader(headers));
    return this.http.get(url, { headers: header }).map(this.extractData).catch(this.handleError);
  }
  authGet2(url:string) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(url, { headers: headers }).map(this.extractData).catch(this.handleError);
  }
  /**
   * call nonauthorize http post
   * @param {string} url
   * @param {Object} data
   */
  post(url: string, data: Object) {
    let headers = new Headers();
    this.createHeader(headers);
    return this.http.post(url, data, { headers: headers }).map(this.extractData).catch(this.handleError);
  }

  postHtml(url: string, data: any) {
    return this.http.post(url, data);
  }

  /**
   * call authorize http post
   * @param {string} url
   * @param {Object} data
   */
  authPost(url: string, data: Object) {
    // let body = JSON.stringify(data);
    let headers = new Headers();
    let header = new Headers(this.createAuthorizationHeader(headers));

    return this.http.post(url, data, { headers: header }).map(this.extractData).catch(this.handleError);
  }

  /**
   * call authorize http post
   * @param {string} url
   * @param {Object} data
   */
  authPut(url: string, data: Object) {
    // let body = JSON.stringify(data);
    let headers = new Headers();
    // this.createAuthorizationHeader(headers);
    let header = new Headers(this.createAuthorizationHeader(headers));
    return this.http.put(url, data, { headers: header }).map(this.extractData).catch(this.handleError);
  }

  /**
   * call authorize http post with set id
   * @param {string} url
   * @param {Object} data
   */
  authPostWithSetId(url: string, data: Object, setId) {
    // let body = JSON.stringify(data);
    let headers = new Headers();
    let header;
    // to check it is user loged or with out login payment
    let authKey = this.cookieManagerService.getCookie(this.loginKey, false).toString();

    if ((authKey || false)) {
      header = new Headers(this.createAuthorizationHeader(headers));
      // header.append(this.setId, String(setId));
    } else {
      header = new Headers(this.createPaymentAuthorizationHeader(headers));
      // header.append(this.setId, String(setId));
    }
    // let header = new Headers(this.createAuthorizationHeader(headers));
    header.append(this.setId, String(setId));
    return this.http.post(url, data, { headers: header }).map(this.extractData).catch(this.handleError);
  }

  authPostWithSetIdForPayment(url: string, data: Object, setId) {
    let authKey = this.cookieManagerService.getCookie(this.loginKey, false).toString();
    let headers = new Headers();
    let header;
    if ((authKey || false)) {
      header = new Headers(this.createAuthorizationHeader(headers));
    } else {
      header = new Headers(this.createPaymentAuthorizationHeader(headers));
    }
    // let header = new Headers(this.createAuthorizationHeader(headers));
    header.append(this.setId, String(setId));
    return this.http.post(url, data, { headers: header }).map(this.extractData).catch(this.handleError);
  }

  authPostWithSetIdPartID(url: string, data: Object, setId) {
    // let body = JSON.stringify(data);
    let headers = new Headers();
    // this.createAuthorizationHeader(headers);
    let header = new Headers(this.createAuthorizationHeader(headers));
    header.append(this.setId, String(setId));
    return this.http.post(url, data, { headers: header }).map(this.extractData).catch(this.handleError);
  }

  /**
   * call authorize http post with part id
   * @param {string} url
   * @param {Object} data
   */
  authPostWithPartId(url: string, data: Object, partId) {
    // let body = JSON.stringify(data);
    let headers = new Headers();
    // this.createAuthorizationHeader(headers);
    let header = new Headers(this.createAuthorizationHeader(headers));
    header.append("partid", partId);
    return this.http.post(url, data, { headers: header }).map(this.extractData).catch(this.handleError);
  }

  /**
   * call authorize http post with set id
   * @param {string} url
   * @param {Object} data
   */
  imageUploadPost(url: string, data: any) {
    var formData = new FormData();
    formData.append("file", data);
    let headers = new Headers();
    headers.append(this.authKey, this.cookieManagerService.getCookie(this.loginKey, false).toString());
    return this.http.post(url, formData, { headers: headers }).map(this.extractData).catch(this.handleError);
  }

  /**
   * Response data extract
   * @param {Response} res
   * return response data Oject
   */
  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }

  /**
   * Handle error after http call
   * @param {any} error
   * return Observable error object;
   */
  private handleError(error: any) {
    return Observable.throw(error);
  }

  /**
   * call authorize http post FOR payment
   * @param {string} url
   * @param {Object} data
   */
  authPaymentPost(url: string, data: Object) {
    let authKey = this.cookieManagerService.getCookie(this.loginKey, false).toString();
    let headers = new Headers();
    let header;
    if ((authKey || false)) {
      header = new Headers(this.createAuthorizationHeader(headers));
    } else {
      header = new Headers(this.createPaymentAuthorizationHeader(headers));
    }

    return this.http.post(url, data, { headers: header }).map(this.extractData).catch(this.handleError);
  }

  /**
   * set auth key using registrationFeeTokenService
   * @param headers
   */
  createPaymentAuthorizationHeader(headers: Headers) {
    try {
      headers.append(this.authKey, this.registrationFeeTokenService.getRegistrationToken());
      return headers;
    } catch (exception) {
      return Observable.throw(exception);
    }
  }

  /**
   * call authorize http get
   * @param {string} url
   */
  authPaymentGet(url: string, setid: any) {
    if (setid && typeof setid === 'object')
      var d = Object.keys(setid).length;

    let headers = new Headers();
    let header ;
    let authKey = this.cookieManagerService.getCookie(this.loginKey, false).toString();

    if (d > 1) {
      headers.append(this.setId, String(setid.setid));
      headers.append(this.catagoryId, String(setid.catagoryid));
    } else {
      headers.append(this.setId, String(setid));
    }
    // let header = new Headers(this.createAuthorizationHeader(headers));
    if ((authKey || false)) {
      header = new Headers(this.createAuthorizationHeader(headers));
    } else {
      header = new Headers(this.createPaymentAuthorizationHeader(headers));
    }
    return this.http.get(url, { headers: header }).map(this.extractData).catch(this.handleError);
  }

  /**
   * call authorize http post
   * @param {string} url
   * @param {Object} data
   */
  authPaymentPut(url: string, data: Object) {
    // let body = JSON.stringify(data);
    let authKey = this.cookieManagerService.getCookie(this.loginKey, false).toString();
    let headers = new Headers();
    let header : any;
    // this.createAuthorizationHeader(headers);
    if ((authKey || false)) {
      header = new Headers(this.createAuthorizationHeader(headers));
    } else {
      header = new Headers(this.createPaymentAuthorizationHeader(headers));
    }
    // let header = new Headers(this.createAuthorizationHeader(headers));
    return this.http.put(url, data, { headers: header }).map(this.extractData).catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/http-client.service.ts